import React from 'react'
import Banner from '../components/Banner'
import Feature from '../components/Feature'
import TopProduct from '../components/TopProduct'
import Coundown from '../components/Coundown'
import Featured from '../components/Featured'
import Play from '../components/Play'
import Feedback from '../components/Feedback'
import Blog from '../components/Blog'


const Home = () => {
  return (
    <>
      <Banner/>
      <Feature/>
      <TopProduct/>
      <Coundown/>
      <Featured/>
      <Play/>
      <Feedback/>
      <Blog/>
    </>
  )
}

export default Home
